import { render, staticRenderFns } from "./Bridge.vue?vue&type=template&id=4d2d4a33&scoped=true"
import script from "./Bridge.vue?vue&type=script&lang=js"
export * from "./Bridge.vue?vue&type=script&lang=js"
import style0 from "./Bridge.vue?vue&type=style&index=0&id=4d2d4a33&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2d4a33",
  null
  
)

export default component.exports